'use strict';

const react = require('@emotion/react');
const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_navigation_PageNavigation_NestedThirdRow = require('./NestedThirdRow.cjs.js');
const components_navigation_PageNavigation_PageNavigationBadge = require('./PageNavigationBadge.cjs.js');
const components_navigation_PageNavigation_PageNavigationRow = require('./PageNavigationRow.cjs.js');
const components_navigation_PageNavigation_utils_checkIsTruncated = require('./utils/checkIsTruncated.cjs.js');

const Styles = {
  list: react.css`
    list-style: none;
    margin: 0;
    padding: 0;
  `,
  textEllipsis: (textColor) => react.css`
    color: ${theme_Colors.Colors[textColor]};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  // The width value for textWrap is 90% of the row width, less the width
  // of the space available for the Badge count (32px) and less the 13px
  // difference in text indentation between the first and second nested
  // rows.
  textWrap: react.css`
    align-items: center;
    display: flex;
    flex-direction: row;
    width: calc(90% - 45px);
  `,
  rowContainer: react.css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: var(--zds-space-8) var(--zds-space-24) var(--zds-space-8)
      var(--zds-space-40);
    position: relative;
  `
};
function NestedSecondRow({ item, onSelect }) {
  const [isTruncated, setIsTruncated] = React.useState(false);
  const textRef = React.useRef(null);
  React.useEffect(() => {
    setIsTruncated(components_navigation_PageNavigation_utils_checkIsTruncated(textRef));
  }, []);
  const InnerContent = ({ hover, selected }) => {
    const textColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm10";
    const textType = selected ? "Body3" : "Body2";
    return react.jsx(
      "div",
      { css: Styles.rowContainer, "data-zds": true },
      react.jsx(
        "span",
        { css: Styles.textWrap, "data-zds": true },
        react.jsx(
          "span",
          { css: Styles.textEllipsis(textColor), ref: textRef, "data-zds": true },
          react.jsx(components_display_Text_Text.Text, { color: textColor, margin: "0 0 0 8px", type: textType }, item.title)
        )
      ),
      item.count && react.jsx(components_navigation_PageNavigation_PageNavigationBadge, { variant: "neutral" }, item.count.toString())
    );
  };
  const Content = ({ hover, selected }) => isTruncated ? react.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { allowMultilineTooltip: true, content: item.title, isBlock: true, position: "northeast" }, () => react.jsx(InnerContent, { hover, selected })) : react.jsx(InnerContent, { hover, selected });
  const NestedList = React.useMemo(() => item.children ? () => {
    var _a;
    return react.jsx("ul", { css: Styles.list, "data-zds": true }, (_a = item.children) === null || _a === void 0 ? void 0 : _a.map((i) => react.jsx(components_navigation_PageNavigation_NestedThirdRow, { item: i, key: i.id, onSelect })));
  } : void 0, [item, onSelect]);
  return react.jsx(components_navigation_PageNavigation_PageNavigationRow, { content: Content, item, nestedList: NestedList, onSelect });
}

module.exports = NestedSecondRow;
//# sourceMappingURL=NestedSecondRow.cjs.js.map
